import { VuexModule, Module, getModule, Mutation, Action } from 'vuex-module-decorators';
import store from '@/store/store';
import { ControllerEvent, Notification, CounterValue, HistoryValues } from '../models';
import {  getControllerEvents, getNotifications, getCounterValuesByControllerID, getCounterValuesOnDate,
  getCounterValuesOnPeriod, getCountersTicks, getHistoryValues } from '../api';

@Module({
  namespaced: true,
  name: 'statistics',
  dynamic: true,
  store,
})
class StatisticsModule extends VuexModule {
  public historyValues: HistoryValues = { dates: [], values: [] } as HistoryValues;
  public notifications: Notification[] | null = null;
  public counterValuesPerController: Map<number, CounterValue[]> | null = null;
  public counterValues: CounterValue[] | null = null;
  public passhash: string = '';
  private controllerEvents: ControllerEvent[] = [];

  get theControllerEvents() {
    return this.controllerEvents;
  }

  @Mutation
  public clean() {
    this.notifications = null;
    this.counterValuesPerController = null;
    this.counterValues = null;
    this.passhash = '';
    this.controllerEvents = [];
    this.historyValues = { dates: [], values: [] } as HistoryValues;
  }

  @Mutation
  public setCtrlEvents(controllerEvents: ControllerEvent[]) {
    // @ts-ignore
    controllerEvents.sort((a, b) => new Date(b.date) - new Date(a.date));
    this.controllerEvents = controllerEvents;
  }

  @Mutation
  public setNotifications(notifications: Notification[]) {
    notifications.sort((a, b) => a.id - b.id);
    this.notifications = notifications;
  }

  @Mutation
  public setCounterValues(values: CounterValue[]) {
    // notifications.sort((a, b) => a.id - b.id);
    // var valuesMap: Map<number, CounterValue[]> = new Map<number, CounterValue[]>();
    // console.log(valuesMap);
    // values.forEach((v, i) => {
    //   if (valuesMap.has(v.controllerId) == undefined) {
    //     valuesMap.set(v.controllerId, []);
    //   }
    //   valuesMap.get(v.controllerId)!.push(v);
    // });
    // console.log(valuesMap);
    this.counterValues = values;
  }

  @Mutation
  public setHistoryValues(history: HistoryValues) {
    this.historyValues = history;
  }

  @Action({commit: 'setCtrlEvents'})
  public async getControllerEvents(params: {uid: number, seen: number}) {
    return await getControllerEvents(params.uid, params.seen);
  }

  @Action({commit: 'setNotifications'})
  public async getNotifications(params: {uid: number, seen: number}) {
    return await getNotifications(params.uid, params.seen);
  }

  // @Action({commit: 'setCounterValues'})
  // public async getCounterValues(uid: number) {
  //   return await getCounterValues(uid);
  // }

  @Action({/* TODO restore commit: 'setCounterValuesByControllerID'*/})
  public async getCounterValuesByControllerID(params: {uid: number, id: number}) {
    return await getCounterValuesByControllerID(params.uid, params.id);
  }

  @Action({/* TODO restore commit: ''*/})
  public async getCounterValuesOnDate(params: {uid: number, id: number, date: string}) {
    return await getCounterValuesOnDate(params.uid, params.id, params.date);
  }

  @Action({/* TODO restore commit: ''*/})
  public async getCounterValuesOnPeriod(params: {uid: number, id: number, datefrom: string, dateto: string}) {
    return await getCounterValuesOnPeriod(params.uid, params.id, params.datefrom, params.dateto);
  }

  @Action({/*commit: 'setCountersTicks'*/})
  public async getCountersTicks(params: {uid: number, ctrlid: number, datefrom: string, dateto: string}) {
    return await getCountersTicks(params.uid, params.ctrlid, params.datefrom, params.dateto);
  }

  @Action({commit: 'setHistoryValues'})
  public async getHistoryValues(params: {uid: number, ctrlid: number}) {
    return await getHistoryValues(params.uid, params.ctrlid);
  }
}

export default getModule(StatisticsModule);
